import { CancelToken } from 'api';
import { get } from 'features/api';
import { FetchProjectConfigurationResponse } from '../types';

export const fetchProjectConfiguration = (projectConfigurationId: string, cancelToken?: CancelToken) => {
  return get<FetchProjectConfigurationResponse>(
    `project-configuration/${projectConfigurationId}`,
    {},
    { cancelToken },
  );
};
